import React from "react";
import styled from "styled-components";

export default styled.a`
    color: white;
    background: #5562c0;
    height: 52px;
    min-width: 105px;
    text-align: center;
    margin-left: 10px;
    display: inline-block;
    padding: 14px;
    cursor: pointer;

    img {
        margin-left: 12px;
        width: 7px;
    }
`;